var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCheckIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8114 10.7759L2.36413 7.3286C1.97636 6.94083 1.348 6.93972 0.958863 7.32612C0.567775 7.71445 0.566658 8.34665 0.956372 8.73636L5.10429 12.8843C5.49482 13.2748 6.12798 13.2748 6.51851 12.8843L17.0484 2.35434C17.4359 1.96688 17.4359 1.33869 17.0484 0.951227C16.6611 0.563896 16.0332 0.563748 15.6457 0.950896L5.8114 10.7759Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheckIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/check-icon.a7cc6ae1.svg";
export { ForwardRef as ReactComponent };